// The «Отправлено» tab of a letter template (platform П9): how many letters went by this template and the last of them.

import { useRecord } from '../sync/react.tsx';
import { LinkedTable } from '../record/LinkedTable.tsx';
import s from './mail.module.css';

export function TemplateSent({ recordId }: { recordId: string }) {
  const rec = useRecord(recordId);
  if (!rec) return null;
  const key = String(rec.data.key ?? '').trim();
  if (!key) return <div className={s.empty}>У шаблона нет кода — письма по нему не считаются.</div>;
  return (
    <LinkedTable
      select={{ typeKey: 'email_message', where: { field: 'template', value: key }, sort: [{ field: 'createdAt', dir: 'desc' }], limit: 20 }}
      columns={['subject', 'to', 'status', 'createdAt']}
      title="Отправлено"
      empty="По этому шаблону писем не было."
    />
  );
}
